import React, { createContext, useState, useContext, useMemo, useEffect } from 'react';

const ChatbotContext = createContext();

// Extract community slug from URL path (once on initial load)
const extractCommunitySlugFromURL = () => {
  if (typeof window === 'undefined') return undefined;
  
  const path = window.location.pathname;
  // Match pattern: /apartments/{area}/{city}/{community-slug} or /apartments/{area}/{city}/{community-slug}/...
  const match = path.match(/\/apartments\/[^\/]+\/[^\/]+\/([^\/]+)/);
  return match ? match[1] : undefined;
};

export const ChatbotProvider = ({ children }) => {
  const [communitySlug, setCommunitySlug] = useState(undefined);
  const [isInitialized, setIsInitialized] = useState(false);

  // Set initial community slug from URL on mount (client-side only, once)
  useEffect(() => {
    if (!isInitialized && typeof window !== 'undefined') {
      const initialSlug = extractCommunitySlugFromURL();
      if (initialSlug) {
        setCommunitySlug(initialSlug);
        console.log('ChatbotContext: Set initial community slug from URL:', initialSlug);
      }
      setIsInitialized(true);
    }
  }, [isInitialized]);

  // Use useMemo to prevent unnecessary re-renders of consumers 
  // when the provider itself re-renders but the context value hasn't changed.
  const value = useMemo(() => ({
    communitySlug,
    // setCommunitySlug removed - slug is set once from URL and never changes
  }), [communitySlug]);

  return (
    <ChatbotContext.Provider value={value}>
      {children}
    </ChatbotContext.Provider>
  );
};

// Custom hook to use the Chatbot context
export const useChatbotContext = () => {
  const context = useContext(ChatbotContext);
  if (context === undefined) {
    throw new Error('useChatbotContext must be used within a ChatbotProvider');
  }
  return context;
}; 